
document.addEventListener("DOMContentLoaded", function () {
  const sidebar = document.querySelector(".collection__page-sidebar");
  if (!sidebar) return;
  const isMobile = () => window.innerWidth <= 768;
  const getAllDetails = () => [...sidebar.querySelectorAll(".details")];
  const enforceSingleOpen = (keepOpen) => {
    getAllDetails().forEach((item) => {
      if (item !== keepOpen && item.hasAttribute("open")) {
        item.removeAttribute("open");
      }
    });
  };
  const closeAllDetails = () => {
    if (!isMobile()) return;
    getAllDetails().forEach((item) => item.removeAttribute("open"));
  };
  closeAllDetails();
  sidebar.addEventListener(
    "toggle",
    (e) => {
      if (!isMobile()) return;
      const target = e.target;
      if (!target.matches(".details")) return;

      if (target.hasAttribute("open")) {
        enforceSingleOpen(target);
      }
    },
    true
  );
  const observer = new MutationObserver((mutations) => {
    if (!isMobile()) return;
    let sawNewNodes = false;
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        sawNewNodes = true;
      }
    });
    if (!sawNewNodes) return;
    const openDetails = getAllDetails().filter((item) => item.hasAttribute("open"));
    if (openDetails.length > 1) {
      const withChecked =
        openDetails.find((item) => item.querySelector("input:checked")) || openDetails[0];
      enforceSingleOpen(withChecked);
    }
  });
  observer.observe(sidebar, {
    subtree: true,
    childList: true, 
  });

  window.addEventListener("resize", closeAllDetails);
});



{
  document.addEventListener("DOMContentLoaded", () => {
  if (!window.matchMedia("(max-width: 980px)").matches) return;

  const initFilterToggle = () => {
    document.querySelectorAll(".filtr_tog_head").forEach((toggle) => {
      if (toggle.dataset.filterInit) return;
      toggle.dataset.filterInit = "true";

      const sidebar = toggle
        .closest(".collection__page")
        ?.querySelector(".collection__page-sidebar");

      if (!sidebar) return;
      toggle.addEventListener("click", (e) => {
        e.stopPropagation();
        sidebar.classList.toggle("Isactive");
      });
      const closeBtn = sidebar.querySelector(".closedFilt");
      if (closeBtn && !closeBtn.dataset.closeInit) {
        closeBtn.dataset.closeInit = "true";

        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          sidebar.classList.remove("Isactive");
        });
      }
      sidebar.addEventListener("click", (e) => {
        e.stopPropagation();
      });

      document.addEventListener("click", () => {
        sidebar.classList.remove("Isactive");
      });
    });
  };
  initFilterToggle();
  const observer = new MutationObserver(() => {
    initFilterToggle();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
}


// {
//   document.addEventListener("DOMContentLoaded", () => {
//   const setButtonText = () => {
//     const btn = document.querySelector(".AddtoCart.preorder-true");
//     if (btn && btn.textContent.trim() !== "Preorder Now!") {
//       btn.textContent = "Preorder Now!";
//     }
//   };

//   setButtonText();

//   document.addEventListener("change", (e) => {
//     if (
//       e.target.matches("input[name='id'], input[type='radio'], select[name='id']")
//     ) {
//       setTimeout(setButtonText, 50);
//     }
//   });
// });
// }
document.addEventListener("DOMContentLoaded", () => {
  const setButtonText = () => {
    const btn = document.querySelector(".AddtoCart.preorder-true");

    if (!btn) return;

    if (btn.disabled) {
      btn.textContent = "Sold Out";
    } else {
      btn.textContent = "Preorder Now!";
    }
  };

  setButtonText();

  document.addEventListener("change", (e) => {
    if (
      e.target.matches("input[name='id'], input[type='radio'], select[name='id']")
    ) {
      setTimeout(setButtonText, 50);
    }
  });

  // Check if button becomes disabled/enabled dynamically
  const observer = new MutationObserver(setButtonText);

  const btn = document.querySelector(".AddtoCart.preorder-true");

  if (btn) {
    observer.observe(btn, {
      attributes: true,
      attributeFilter: ["disabled"]
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const popupButtons = document.querySelectorAll(".POPUP_BTN");
  const popups = document.querySelectorAll(".popup_PDP_wrap");
  const closeButtons = document.querySelectorAll(".closed__pop");

  popupButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const popupType = this.getAttribute("data-popup");
      const popup = document.querySelector(
        `.popup_PDP_wrap[data-popup-content="${popupType}"]`
      );

      if (popup) {
        popup.classList.add("active");
        document.body.classList.add("pdp-popup-open");
      }
    });
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", function () {
      const popup = this.closest(".popup_PDP_wrap");

      if (popup) {
        popup.classList.remove("active");
        document.body.classList.remove("pdp-popup-open");
      }
    });
  });

  // Close popup when clicking outside the popup content
  popups.forEach((popup) => {
    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        popup.classList.remove("active");
        document.body.classList.remove("pdp-popup-open");
      }
    });
  });

  // Close popup with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      popups.forEach((popup) => {
        popup.classList.remove("active");
      });

      document.body.classList.remove("pdp-popup-open");
    }
  });
});


